import { __assign } from "tslib";
import React from 'react';
import { DragDropContext as RBDDragDropContext, } from 'react-beautiful-dnd';
import { useThemeProps } from '../../../foundation';
import { GlobalDraggableStyle } from './styles';
var RcDragDropContext = function (inProps) {
    var props = useThemeProps({ props: inProps, name: 'RcDragDropContext' });
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalDraggableStyle, null),
        React.createElement(RBDDragDropContext, __assign({}, props))));
};
RcDragDropContext.defaultProps = {};
RcDragDropContext.displayName = 'RcDragDropContext';
export { RcDragDropContext };
